import { classNames } from '@/shared/lib/classNames/classNames';

interface CasesDividerProps {
  className?: string;
}

export const CasesDivider = ({ className }: CasesDividerProps) => {
  return (
    <div
      className={classNames({
        cls: 'bg-stroke-accent my-10 h-[6px] w-[66px] max-sm:mt-6 max-sm:mb-9 max-sm:h-[4px]',
        additional: [className],
      })}
    />
  );
};
